export default __webpack_public_path__ + "5642e53e3a27904096a941a4b04b9d77.svg";